<script setup lang="ts">
import WaterFall from "@/components/WaterFall.vue";
import Water from "@/components/Water.vue";
import { List } from "vant";
import { useI18n } from "vue-i18n";
import { ref } from "vue";
import _service from "@/service";
import { onMounted } from "vue";
import { Loading } from "vant";
import { Tab, Tabs } from "vant";
const activeModule = ref("product"); // product/store
const categoryList = ref<any>([]);
const activeTab = ref<string | number>("");
const productList = ref<any>([]);
const pageNo = ref<number>(1);
const keyword = ref<string>("");
const clickTimes = ref(0);
const finished = ref<boolean>(false);
const loading = ref<boolean>(false);
const showExpand = ref<boolean>(false);
const categoryCurrentId = ref<string | number>("");

onMounted(() => {
  function getLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          console.log("纬度: ", position.coords.latitude);
          console.log("经度: ", position.coords.longitude);
          console.log("高度: ", position.coords.altitude);
        },
        function (error) {
          console.error("无法获取位置信息: ", error.message);
        }
      );
    } else {
      console.error("浏览器不支持地理位置定位。");
    }
  }

  getLocation();

  getProductCategoryList();
});

const getProductCategoryList = async () => {
  const res = await _service.getProductCategoryList();
  res.data.unshift({
    name: "全部",
    id: "1,2",
  });
  categoryList.value = res.data;
  // getProductList()
};

const changeCategory = (data: any) => {
  const { name } = data;
  categoryCurrentId.value = name;
  activeTab.value = name;
  resetList();
  onLoad();
};

const getProductList = async () => {
  if (finished.value) {
    return false;
  }
  loading.value = true;
  const { data } = await _service.getProductByCategoryId({
    pageNo: pageNo.value,
    pageSize: 20,
    keyword: keyword.value,
    categoryIds: categoryCurrentId.value,
  });
  loading.value = false;
  productList.value = productList.value.concat(data.list);
  if (productList.value.length >= data.total) {
    finished.value = true;
    return false;
  }
  pageNo.value = pageNo.value + 1;
};

const resetList = () => {
  productList.value = [];
  pageNo.value = 1;
  finished.value = false;
};

const clickLogo = () => {
  clickTimes.value++;
  sessionStorage.setItem("clickLogoTImes", `${clickTimes.value}`);
  if (clickTimes.value >= 7) {
    var vConsole = new window.VConsole();
  }
  // var vConsole = new window.VConsole();
};

const onLoad = () => {
  console.log("onLoad");
  getProductList();
};

const searchProduct = () => {
  resetList();
  getProductList();
};
</script>

<script lang="ts">
export default {
  name: "Home",
};
</script>

<template>
  <div class="home-layout">
    <div class="">
      <div class="header flex-row-between-center">
        <div class="left flex-row-start-center">
          <!-- <span class="back-icon"></span> -->
          <div class="title" @click="$router.push('/')">商城</div>
        </div>
        <div
          class="expand"
          @click="showExpand = !showExpand"
          v-clickOutSide="
            () => {
              showExpand = false;
            }
          "
        >
          ···
        </div>
        <div class="expand-list" :class="{ active: showExpand }">
          <a
            href="https://h5.starnest.app/notice/detail/22"
            class="expand-list-item"
            >隱私協議</a
          >
          <a
            href="https://h5.starnest.app/notice/detail/33"
            class="expand-list-item"
            >關於我們</a
          >
          <a
            href="https://h5.starnest.app/notice/detail/34"
            class="expand-list-item"
            >聯絡我們</a
          >
          <a
            href="https://h5.starnest.app/notice/detail/35"
            class="expand-list-item"
            >退款政策</a
          >
          <router-link
            to="/my-order"
            class="expand-list-item"
            >我的訂單</router-link
          >
        </div>
        <!-- <div class="right tabs flex-row-between-center">
          <div class="tab-slider" :class="activeModule"></div>
          <div
            class="tab product flex-row-center-center"
            :class="{ active: activeModule === 'product' }"
            @click="activeModule = 'product'"
          >
            <span class="icon product-icon"></span><span class="text">商品</span>
          </div>
          <div
            class="tab store flex-row-center-center"
            :class="{ active: activeModule === 'store' }"
            @click="activeModule = 'store'"
          >
            <span class="icon store-icon"></span><span class="text">店铺</span>
          </div>
        </div> -->
      </div>

      <div class="content-layout">
        <div class="search-wrapper">
          <div class="search-bar flex-row-start-center">
            <input type="text" placeholder="搜索商品标题" v-model="keyword" />
            <span
              class="search-btn flex-row-center-center"
              @click="searchProduct()"
            >
              <span class="search-icon"></span>
            </span>
          </div>
        </div>
        <Tabs
          v-model:active="activeTab"
          @click-tab="changeCategory"
          scrollspy
        >
          <Tab
            :title="item.name"
            :name="item.id"
            v-for="item in categoryList"
            :key="item.id"
          >
            <div class="product-box">
              <List
                v-model:loading="loading"
                :finished="finished"
                @load="onLoad"
                offset="500"
              >
                <div class="no-data" v-if="finished && !productList.length">
                  暂无数据
                </div>
                <Water
                  height="calc(100vh - 180px)"
                  :list="productList"
                  @loadMore="getProductList"
                ></Water>
              </List>
            </div>
          </Tab>
        </Tabs>
        <div class="store-box" v-show="activeModule === 'store'">
          <router-link to="/store-detail" class="store-item" v-for="item in 12">
            <div class="store-info">
              <div class="flex-row-between-center">
                <div class="name flex-row-start-center">
                  <span class="store-icon"></span>店铺标题店铺标题店铺标题
                </div>
                <div class="right-icon"></div>
              </div>
              <div class="address">店铺地址店铺地址店铺地...</div>
            </div>
            <div class="store-product flex-row-between-center">
              <div class="left flex-col-between-start">
                <p class="flex-row-start-center">
                  <span class="hot-text">热卖中</span><span class="hot"></span>
                </p>
                <p>
                  <span class="number-font">3412 </span
                  ><span class="text">On sale</span>
                </p>
              </div>
              <div class="right">
                <img
                  src="../../assets/product-avatar.png"
                  class="produc-img"
                  v-for="item in 4"
                  alt=""
                />
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.home-layout {
  height: 100%;
  min-height: 100vh;
  width: 100%;
  background: url(../../assets/home-back.svg);
  background-repeat: no-repeat;
  background-size: contain;
  overflow: hidden;
  @media screen and (min-width: 768px) {
    background-size: cover;
  }
  .header {
    width: 100%;
    height: 68px;
    padding: 0 16px;
    .left {
      .back-icon {
        width: 24px;
        height: 24px;
        background: url(../../assets/back-icon.svg);
        background-repeat: no-repeat;
        background-size: contain;
        margin-right: 4px;
      }
      .title {
        position: relative;
        font-size: 18px;
        font-weight: 600;
        color: #000;
        z-index: 1;
        &::after {
          display: inline-block;
          content: "";
          position: absolute;
          width: 64px;
          height: 44px;
          background: url(../../assets/title-icon.svg);
          background-repeat: no-repeat;
          background-size: contain;
          right: -28px;
          top: 50%;
          transform: translateY(-50%);
          z-index: -1;
        }
      }
    }

    .expand {
      font-size: 20px;
      font-weight: 900;
      cursor: pointer;
      + .expand-list {
        position: absolute;
        z-index: 22;
        right: 0;
        top: 50px;
        display: none;
        width: 80px;
        border-radius: 8px;
        background-color: rgba($color: #ffffff, $alpha: 1);
        overflow: hidden;
        .expand-list-item {
          display: block;
          cursor: pointer;
          text-align: center;
          padding: 8px 0;
          font-size: 14px;
          color: #000;
          &:hover {
            background-color: rgba($color: #000, $alpha: 0.1);
          }
        }
        &.active {
          display: block;
        }
      }
    }
    .link {
      color: #000;
    }
    .tabs {
      position: relative;
      width: 150px;
      height: 38px;
      border-radius: 100px;
      border: 1px solid #fff;
      background: rgba(255, 255, 255, 0.3);
      .tab-slider {
        position: absolute;
        width: 96px;
        height: 100%;
        border-radius: 100px;
        background: linear-gradient(
          224deg,
          #eaadff 0%,
          #efdbff 44.6%,
          #76d6ff 98.01%
        );
        transition: all 0.2s;
        &.product {
          transform: translateX(0);
        }
        &.store {
          transform: translateX(52px);
        }
      }
      .tab {
        width: 52px;
        .text {
          display: none;
        }
        &.active {
          width: 96px;
          font-size: 14px;
          gap: 5px;
          flex: 1;
          .icon {
            filter: grayscale(0%);
          }
          .text {
            display: inline-block;
          }
        }
        .product-icon {
          display: block;
          width: 26px;
          height: 26px;
          background: url(../../assets/product.png);
          background-size: contain;
          background-repeat: no-repeat;
          filter: grayscale(100%);
          transition: all 0.5s;
        }
        .store-icon {
          display: block;
          width: 24px;
          height: 24px;
          background: url(../../assets/store.png);
          background-size: contain;
          background-repeat: no-repeat;
          filter: grayscale(100%);
          transition: all 0.5s;
        }
      }
    }
  }
  .content-layout {
    :deep(.van-tab) {
      flex: unset;
    }
    @media screen and (min-width: 768px) {
      width: 80%;
      margin: 0 auto;
    }
    @media screen and (min-width: 1000px) {
      width: 80%;
      margin: 0 auto;
    }
    @media screen and (min-width: 1300px) {
      width: 1200px;
      margin: 0 auto;
    }
  }
  .search-wrapper {
    width: 100%;
    padding: 0 16px;
    @media screen and (min-width: 500px) {
      width: 492px;
    }
    .search-bar {
      padding: 6px 6px 6px 20px;
      width: 100%;
      height: 40px;
      border-radius: 12px;
      border: 1px solid #070b14;
      background: #fff;
      input {
        flex: 1;
        &::placeholder {
          color: #9c9caa;
        }
      }
      .search-btn {
        width: 48px;
        height: 28px;
        border-radius: 10px;
        background: #070b14;
        cursor: pointer;
        .search-icon {
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../../assets/search-icon.svg);
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
    }
  }
  .category-wrapper {
    width: 100vw;
    overflow-x: scroll;
    padding: 16px;
    /* @media screen and (min-width: 768px) {
      width: 100%;
    } */
  }
  .product-box {
    /* height: calc(100vh - 172px); */
    height: calc(100vh - 168px);
    /* height: 100%; */
    overflow-y: scroll;
    /* .van-list{
      height: 100%;
    } */
    &::-webkit-scrollbar {
      width: 0;
    }
    &::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 12px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba($color: #29c1cc, $alpha: 0.58);
      border-radius: 12px;
      width: 4px;
      height: 14px;
    }
  }
  .store-box {
    height: calc(100vh - 164px);
    overflow-y: scroll;
    padding: 0 14px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 16px;

    .store-item {
      width: 100%;
      padding: 12px;
      border-radius: 12px;
      background: #fff;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      .store-info {
        color: #000;
        font-size: 16px;
        .address {
          font-size: 12px;
          color: #9c9caa;
          margin-top: 10px;
        }
        .store-icon {
          width: 24px;
          height: 24px;
          background: url(../../assets/store.png);
          background-repeat: no-repeat;
          background-size: contain;
          margin-right: 4px;
        }
        .right-icon {
          width: 16px;
          height: 16px;
          background: url(../../assets/right-icon.svg);
          background-repeat: no-repeat;
          background-size: contain;
        }
      }
      .store-product {
        width: 100%;
        height: 60px;
        margin-top: 16px;
        border-radius: 10px;
        background: #f4f5f6;
        padding: 6px 8px;
        .left {
          height: 100%;
          .hot-text {
            background: linear-gradient(
              137deg,
              #4bfcc8 2.92%,
              #49fa86 9.01%,
              #39e7ff 96.65%
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-size: 16px;
            font-weight: 700;
            line-height: 1.4;
          }
          .hot {
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../../assets/hot.svg);
            background-repeat: no-repeat;
            background-size: contain;
            margin-left: 2px;
          }
          .number-font {
            font-size: 12px;
            color: #565662;
            margin-right: 4px;
          }
          .text {
            font-size: 10px;
            color: #565662;
          }
        }
        .right {
          display: flex;
          align-items: center;
          flex-direction: row;
          justify-content: start;
          gap: 4px;
          .produc-img {
            width: 48px;
            height: 48px;
            border-radius: 8px;
          }
        }
      }
    }
  }
}

.no-data {
  text-align: center;
  padding: 20px 0;
}
:deep(.van-tabs) {
  padding-top: 16px;
  .van-tabs__nav--line {
    padding-left: 16px;
    padding-bottom: 10px;
  }
}
:deep(.van-tabs--line) {
  .van-tabs__wrap {
    height: unset;
  }
}
:deep(.van-tabs__nav) {
  background: none;
  gap: 16px;
  .van-tab {
    padding: 6px 12px;
    color: #070b14;
    font-size: 12px;
    line-height: 16px;
    border-radius: 6px;
    word-break: keep-all;
    background: #fff;
  }
  .van-tab--active {
    background: linear-gradient(
      224deg,
      #eaadff 0%,
      #efdbff 44.6%,
      #76d6ff 98.01%
    );
  }
  .van-tabs__line {
    display: none;
  }
}
:deep(.van-tabs__content) {
  height: calc(100vh - 168px);
  .van-tab__panel {
    height: 100%;
  }
}
</style>
